var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDivider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1439,
    height: 83,
    viewBox: "0 0 1439 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 51.0001C1.5 51.0001 55.6846 31.0234 92 29.0001C139.187 26.371 163.764 52.5149 211 51.0001C263.464 49.3177 288.272 9.75945 340.5 15.0001C379.069 18.8702 394.33 48.3256 433 51.0001C486.875 54.7261 508.501 3.16245 562.5 2.50009C618.332 1.81526 641.403 45.8415 697 51.0001C751.724 56.0776 781.593 21.2357 836 29.0001C879.721 35.2394 897.099 75.8078 941 71.0001C981.82 66.5298 989.062 18.2238 1030 15.0001C1068.46 11.9713 1083.62 47.0396 1122 51.0001C1174.4 56.4078 1202.25 -2.33238 1252 15.0001C1283.78 26.0729 1283.9 69.0875 1317.5 71.0001C1348.99 72.7929 1355.25 24.6808 1386.5 29.0001C1412.21 32.5535 1438 71.0001 1438 71.0001",
    stroke: "white",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 60.0001C1.5 60.0001 55.6846 40.0234 92 38.0001C139.187 35.371 163.764 61.5149 211 60.0001C263.464 58.3177 288.272 18.7594 340.5 24.0001C379.069 27.8702 394.33 57.3256 433 60.0001C486.875 63.7261 508.501 12.1625 562.5 11.5001C618.332 10.8153 641.403 54.8415 697 60.0001C751.724 65.0776 781.593 30.2357 836 38.0001C879.721 44.2394 897.099 84.8078 941 80.0001C981.82 75.5298 989.062 27.2238 1030 24.0001C1068.46 20.9713 1083.62 56.0396 1122 60.0001C1174.4 65.4078 1202.25 6.66762 1252 24.0001C1283.78 35.0729 1283.9 78.0875 1317.5 80.0001C1348.99 81.7929 1355.25 33.6808 1386.5 38.0001C1412.21 41.5535 1438 80.0001 1438 80.0001",
    stroke: "#FF4D1F",
    strokeWidth: 4
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivider);
export default __webpack_public_path__ + "static/media/divider.417e0e0015e068c9a9166b4ec53638ed.svg";
export { ForwardRef as ReactComponent };